// Iniciar com o computador (configuracoes, AC-128 / AC-129): plugin oficial do Tauri. No Windows
// coloca o app na inicialização do usuário; no Mac, um item de login (LaunchAgent). A escolha
// fica no próprio sistema, em cada computador (ASM-068). Na web não existe (null).
import { isTauri } from './desktop';

export interface AutostartBridge {
  isEnabled(): Promise<boolean>;
  setEnabled(on: boolean): Promise<void>;
}

export async function getAutostart(): Promise<AutostartBridge | null> {
  if (!isTauri()) return null;
  const plugin = await import('@tauri-apps/plugin-autostart');
  return {
    isEnabled: () => plugin.isEnabled(),
    setEnabled: (on) => (on ? plugin.enable() : plugin.disable()),
  };
}

/** a escolha feita nas Configurações deste computador: 'off' impede o app de se religar sozinho */
export const AUTOSTART_CHOICE_KEY = 'beedoit.autostart.choice';

/** O botão das Configurações (AC-129) passa por aqui: além de mudar o sistema, guarda a escolha. */
export function rememberAutostartChoice(
  bridge: AutostartBridge | null,
  storage: Pick<Storage, 'setItem'> | null
): AutostartBridge | null {
  if (!bridge) return null;
  return {
    isEnabled: () => bridge.isEnabled(),
    async setEnabled(on) {
      await bridge.setEnabled(on);
      try {
        storage?.setItem(AUTOSTART_CHOICE_KEY, on ? 'on' : 'off');
      } catch {
        /* sem armazenamento: vale só o estado do sistema */
      }
    },
  };
}

/**
 * Padrão ligado (ASM-065, AC-128): a cada abertura, se o app não está na inicialização e a pessoa
 * não o desligou nas Configurações, ele se coloca de volta — reinstalar pelo instalador apaga a
 * entrada do Windows. A versão de desenvolvimento nunca entra (registraria o executável de teste).
 */
export async function applyAutostartDefault(
  bridge: AutostartBridge | null,
  storage: Pick<Storage, 'getItem'> | null,
  dev: boolean
): Promise<void> {
  if (!bridge || dev) return;
  try {
    if (storage?.getItem(AUTOSTART_CHOICE_KEY) === 'off') return;
    if (!(await bridge.isEnabled())) await bridge.setEnabled(true);
  } catch {
    /* sem permissão: tenta de novo na próxima abertura */
  }
}
